
const ACTIONS = { 
    GET_SALE: "GET_SALE"
};

export default ACTIONS;